module.exports = __webpack_public_path__ + "img/creative@2x.69c3c63.jpg";